import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { View, Text, Page } from '@react-pdf/renderer';
import en from '@mummssoftware/utils/translationDefaults/en';
import { formatDateMMDDYY } from '@mummssoftware/utils/formatters';
import { notesIncluded } from '@mummssoftware/utils/utils';
import { BereavementNotesPDF } from './components/BereavementNotesPDF';
import { styles } from '../../utils';
import { PrintHeaderPDFComponent } from '../Header';
import { PrintFooterPDFComponent } from '../Footer';
import defaults from '../../translations/en.json';

const NoBereavementsComponent = () => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, en.common.noBereavements));

const CareGiverRows = ({
  pdfCareGiversInfo,
  dashboardPrintConfig,
  pdfBereavNotes
}) => {
  var _ref = /*#__PURE__*/React.createElement(BereavementNotesPDF, {
    bereavementNotes: pdfBereavNotes
  });

  const shallowDashboardPrintConfigView = dashboardPrintConfig && _objectSpread({}, dashboardPrintConfig);

  const BereavPrintView = shallowDashboardPrintConfigView === null || shallowDashboardPrintConfigView === void 0 ? void 0 : shallowDashboardPrintConfigView.Bereavement;
  const rowUI = pdfCareGiversInfo && pdfCareGiversInfo.length && pdfCareGiversInfo.map(info => {
    const interventionScheduleArray = info && info.griefriskactions && info.griefriskactions.split('\n');
    const interventionStringArray = interventionScheduleArray && interventionScheduleArray.slice();
    const halfInterventionsLength = interventionStringArray && Math.ceil(interventionStringArray.length / 2);
    const firstHalfInterventionsArray = interventionStringArray && interventionStringArray.slice(0, halfInterventionsLength);
    const secondHalfInterventionsArray = interventionStringArray && interventionStringArray.slice(halfInterventionsLength, interventionStringArray.length - 1);
    return /*#__PURE__*/React.createElement(View, {
      style: styles.borderBottomBlack,
      key: `caregiver-${info.id}`
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.row, styles.width100]
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.width20
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `${info.caregiverlastname || ''}`)), /*#__PURE__*/React.createElement(View, {
      style: styles.width20
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `${info.caregiverfirstname || ''}`)), /*#__PURE__*/React.createElement(View, {
      style: styles.width20
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `${info.caregiverrelationship || ''}`)), /*#__PURE__*/React.createElement(View, {
      style: styles.width20
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `${info.griefRisk || ''}`)), /*#__PURE__*/React.createElement(View, {
      style: styles.width20
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `${formatDateMMDDYY(info.bereavedStartDate)}`))), interventionScheduleArray && /*#__PURE__*/React.createElement(View, {
      style: styles.width100
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontSizeElevenPt, styles.fontFamilyItalic, styles.textDecorationUnderline]
    }, en.common.interventionSchedule), /*#__PURE__*/React.createElement(View, {
      style: [styles.row, styles.width100]
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.width50
    }, firstHalfInterventionsArray && firstHalfInterventionsArray.length > 0 && firstHalfInterventionsArray.map((intervention, i) => /*#__PURE__*/React.createElement(Text // eslint-disable-next-line react/no-array-index-key
    , {
      key: `intervention-${info && info.id}-${i}`,
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `• ${intervention}`))), /*#__PURE__*/React.createElement(View, {
      style: styles.width50
    }, secondHalfInterventionsArray && secondHalfInterventionsArray.length > 0 && secondHalfInterventionsArray.map((intervention, i) => /*#__PURE__*/React.createElement(Text // eslint-disable-next-line react/no-array-index-key
    , {
      key: `intervention-${info && info.id}-${i}`,
      style: [styles.fontSizeTenPt, styles.pYPointOneCm]
    }, `• ${intervention}`))), notesIncluded(BereavPrintView) && pdfBereavNotes && dashboardPrintConfig && _ref)));
  });
  return /*#__PURE__*/React.createElement(View, null, rowUI);
};

var _ref2 = /*#__PURE__*/React.createElement(NoBereavementsComponent, null);

var _ref3 = /*#__PURE__*/React.createElement(PrintFooterPDFComponent, null);

export const BereavementPDF = ({
  dashboardPrintConfig,
  pdfBereavNotes,
  browser,
  pdfCareGiversInfo,
  patient
}) => /*#__PURE__*/React.createElement(Page, {
  wrap: false,
  size: "A4",
  orientation: "portrait",
  style: browser && browser.name === 'safari' || browser && browser.name === 'ios' ? styles.pageSafari : styles.page
}, /*#__PURE__*/React.createElement(PrintHeaderPDFComponent, {
  browser: browser,
  patient: patient
}), /*#__PURE__*/React.createElement(View, {
  style: [styles.textAlignCenter, styles.width100, styles.marginBottomPointFiveCm]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.printerHeaderText]
}, defaults.carePlanBereavement)), /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.row, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, /*#__PURE__*/React.createElement(Text, {
  style: (styles.fontWeightBold, styles.fontSizeTwelvePt)
}, en.common.cgLastName)), /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, /*#__PURE__*/React.createElement(Text, {
  style: (styles.fontWeightBold, styles.fontSizeTwelvePt)
}, en.common.cgFirstName)), /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, /*#__PURE__*/React.createElement(Text, {
  style: (styles.fontWeightBold, styles.fontSizeTwelvePt)
}, en.common.relation)), /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, /*#__PURE__*/React.createElement(Text, {
  style: (styles.fontWeightBold, styles.fontSizeTwelvePt)
}, en.common.riskLevel)), /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, /*#__PURE__*/React.createElement(Text, {
  style: (styles.fontWeightBold, styles.fontSizeTwelvePt)
}, en.common.startDate))), pdfCareGiversInfo && pdfCareGiversInfo.length > 0 && /*#__PURE__*/React.createElement(CareGiverRows, {
  pdfCareGiversInfo: pdfCareGiversInfo,
  dashboardPrintConfig: dashboardPrintConfig,
  pdfBereavNotes: pdfBereavNotes
}) || _ref2, _ref3);